import React from "react";
import { graphql } from "gatsby";
import { RichText } from "../../utils/richText";
import { motion } from "framer-motion";
import { FADE_UP, useInView } from "../animationUtils";
import ArrowSvg from "../arrowSvg";

export const fragments = graphql`
  fragment Page_BoxesWithoutShadow on PrismicPageDataBodyBoxesWithoutShadow {
    items {
      icon {
        url
      }
      title1 {
        text
      }
      body1 {
        richText
      }
      link {
        url
      }
      label_link
    }
  }
  fragment FocusArea_BoxesWithoutShadow on PrismicFocusAreaDataBodyBoxesWithoutShadow {
    items {
      icon {
        url
      }
      title1 {
        text
      }
      body1 {
        richText
      }
      link {
        url
      }
      label_link
    }
  }
  fragment Project_BoxesWithoutShadow on PrismicProjectDataBodyBoxesWithoutShadow {
    items {
      icon {
        url
      }
      title1 {
        text
      }
      body1 {
        richText
      }
      link {
        url
      }
      label_link
    }
  }
  fragment Homepage_BoxesWithoutShadow on PrismicHomepageDataBodyBoxesWithoutShadow {
    items {
      icon {
        url
      }
      title1 {
        text
      }
      body1 {
        richText
      }
      link {
        url
      }
      label_link
    }
  }
`;

function BoxesWithoutShadow({ data }) {
  const { items } = data;
  const [refImage, inViewImage] = useInView();
  const hasLink = items.some(item => item?.link?.url && item?.label_link);

  return (
    <div className="boxes-without-shadow">
      <motion.div
        ref={refImage}
        {...FADE_UP}
        animate={inViewImage ? "start" : ""}
        className="boxes-without-shadow__content"
      >

        {items.map((item, index) => (
          <div className="boxes-without-shadow__item" key={index}>
            {
              item?.icon?.url && (
                <img src={item?.icon?.url} alt={item?.title1?.text} className="boxes-without-shadow__icon" />
              )
            }
            {
                item?.title1?.text && (
                  <h3 className="boxes-without-shadow__headline">{item?.title1?.text}</h3>
                )
              }
                <div className={`boxes-without-shadow__body ${hasLink ? 'boxes-without-shadow__body--with-link' : ''}`}>
                  {
                    item?.body1?.richText &&
                    RichText(item?.body1?.richText)
                  }
                </div>
                {
                  item?.label_link && item?.link?.url && (
                    <a href={item?.link?.url} className="boxes-without-shadow__link">
                      {item?.label_link}
                      <ArrowSvg />
                    </a>
                  )
                }
          </div>
        ))}

      </motion.div>

    </div>
  );
}

export default BoxesWithoutShadow;
